import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable() 
export class PaymentService {
  constructor(private http: HttpClient) {}

  getPaymentMethod(userId, phone, type) {
    return this.http.post(
      `payment#operator/passenger/${userId}/payment_method`,
      { phone, payment_method_type: type }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/services/payment.service.ts